import { Grid } from "@mui/material";
import MxDetailSubTitle from "@rf-l1/page/details/MxDetailSubTitle";
import { usePropertyDetailPage } from "../../context/PropertyDetailPageContext";
import MxDetailLabelValue from "@rf-l1/page/details/MxDetailLabelValue";

const MainDetailGeneral = () => {
  const {
    condition,
    usage,
    arrangementType,
    refPoint,
    position,
    features,
    maintenanceFee,
    visit,
    isInhabited,
    trustName,
    deliveryDate
  } = usePropertyDetailPage();

  return (
    <Grid container gap={2}>
      <Grid item xs={12}>
        <MxDetailSubTitle label="Información General" />
      </Grid>
      <Grid container item xs={12} spacing={1} rowSpacing={2}>
        {condition && (
          <Grid item xs={12} md={6}>
            <MxDetailLabelValue label="Estado del inmueble: " value={condition} />
          </Grid>
        )}

        {usage && (
          <Grid item xs={12} md={6}>
            <MxDetailLabelValue label="Uso del inmueble: " value={usage} />
          </Grid>
        )}

        {arrangementType && (
          <Grid item xs={12} md={6}>
            <MxDetailLabelValue label="Tipo de arreglo: " value={arrangementType} />
          </Grid>
        )}

        {refPoint && (
          <Grid item xs={12} md={6}>
            <MxDetailLabelValue label="Punto de referencia: " value={refPoint} />
          </Grid>
        )}

        {position && (
          <Grid item xs={12} md={6}>
            <MxDetailLabelValue label="Posición: " value={position} />
          </Grid>
        )}
        {features?.halfBathrooms && (
          <Grid item xs={12} md={6}>
            <MxDetailLabelValue
              label="Medios baños: "
              value={features.halfBathrooms.toString()}
            />
          </Grid>
        )}

        {maintenanceFee && (
          <Grid item xs={12} md={6}>
            <MxDetailLabelValue label="Mantenimiento: " value={maintenanceFee} />
          </Grid>
        )}

        {visit && (
          <Grid item xs={12} md={6}>
            <MxDetailLabelValue label="Información de visitas: " value={visit} />
          </Grid>
        )}

        {isInhabited && (
          <Grid item xs={12} md={6}>
            <MxDetailLabelValue label="¿Está habitado?: " value={isInhabited} />
          </Grid>
        )}

        {trustName && (
          <Grid item xs={12} md={6}>
            <MxDetailLabelValue label="Fideicomiso: " value={trustName} />
          </Grid>
        )}

        {deliveryDate && (
          <Grid item xs={12} md={6}>
            <MxDetailLabelValue label="Fecha de entrega: " value={deliveryDate} />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default MainDetailGeneral;
